<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 mb-3 mb-lg-0">
        <div class="row">
          <div class="col-lg-3 mb-2 mb-lg-0">
            <img class="footer__logo" src="/assets/images/logo-white.svg?v={{logoVersionNumber()}}"
              alt="Philly Foodworks" />
          </div>
          <div class="col-6 col-md-5">
            <div class="footer__title" [routerLink]="['/pages/how-it-works/main']">How it Works</div>
            <ul class="footer__list">
              <li><a [routerLink]="['/pages/how-it-works/rewards-program']">Root Rewards Program</a></li>
              <li><a [routerLink]="['/pages/how-it-works/produce-program']">Low Cost Produce Program</a></li>
            </ul>
          </div>
          <div class="col-6 col-md-4">
            <div class="footer__title" [routerLink]="['/pages/about-us/main']">
              About Us
            </div>
            <ul class="footer__list">
              <li><a [routerLink]="['/pages/about-us/support']">Building a Local Food System</a></li>
              <li><a [routerLink]="['/pages/about-us/donations']">Increasing Access to Local Food</a></li>
              <li><a [routerLink]="['/pages/about-us/packaging']">Moving Towards Zero Waste</a></li>
            </ul>
            <div class="footer__title mt-3" [routerLink]="['/pages/faq/prospective-members']">
              FAQ
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="footer__title-list">
          <a [routerLink]="['/pages/producers']">Meet Our Producers</a>
          <a [routerLink]="['/pages/contact-us']">Contact Us</a>
          <a [routerLink]="['/pages/blog']">Blog</a>
          <div class="to-top" (click)="scrollToTop()">
            <i class="icon fa-solid fa-chevron-up"></i>
            <div class="text">To top</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row copy-text mt-2 mt-lg-5">
      <div class="col-sm-6">Philly Foodworks © {{copyRightYear}} | Powered by <a class="link" href="https://navego.tech"
          [target]="'_blank'">Navego</a></div>
      <div class="col-sm-6">
        <ul class="social-icons">
          <li><a href="https://www.facebook.com/phillyfoodworks" target="_blank" aria-label="facebook link"><i
                class="fab fa-facebook"></i></a></li>
          <li><a href="https://www.instagram.com/phillyfoodworks" target="_blank" aria-label="facebook link"><i
                class="fab fa-instagram"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
